<template>
    <div>
        <el-collapse style="width:92%;margin-left:4%;border:1px solid #EBEEF5;height:400px" accordion>
            <el-collapse-item v-for="item in organizeList" :key="item.id">
                <template slot="title">
                    <el-row style="width: 100%;">
                        <el-col :span="1" :offset="1" style="padding-top: 2px;">
                            <img src="../../../assets/icon/迈亚集团icon@2x.png" />
                        </el-col>
                        <el-col :span="10">
                            <span>{{item.organize_name}}</span>
                        </el-col>
                    </el-row>
                </template>

                <div>
                    <el-collapse>
                        <!-- 板块 -->
                        <el-collapse-item v-for="item2 in item.organizeList" :key="item2.id">
                            <template slot="title">
                                <el-row style="width: 100%; padding-left: 5px;">
                                    <el-col :span="1" :offset="2" style="padding-top: 2px;">
                                        <img src="../../../assets/icon/icon2灰@2x.png" />
                                    </el-col>
                                    <el-col :span="10">
                                        <span>{{item2.organize_name}}</span>
                                    </el-col>
                                </el-row>
                            </template>

                            <div>
                                <el-collapse v-model="project_id">
                                    <!-- 项目 -->
                                    <el-collapse-item v-for="item3 in item2.projectList" :key="item3.id"
                                        :name="item3.id">
                                        <template slot="title">
                                            <el-row style="width: 100%; padding-left: 10px;">
                                                <el-col :span="1" :offset="3" style="padding-top: 2px;">
                                                    <img src="../../../assets/icon/icon2灰@2x.png" />
                                                </el-col>
                                                <el-col :span="10">
                                                    <span>{{item3.project_name}}</span>
                                                </el-col>
                                            </el-row>
                                        </template>

                                        <!-- 人员 -->
                                        <div style="width: 80%;padding: 10px 17%;">
                                            <el-checkbox-group v-model="change_staff">
                                                <el-checkbox v-for="item4 in item3.staffList" :key="item4.id"
                                                    :label="item4.id">{{item4.staff_name}}</el-checkbox>
                                            </el-checkbox-group>
                                        </div>

                                    </el-collapse-item>
                                </el-collapse>
                            </div>

                        </el-collapse-item>
                    </el-collapse>
                </div>

            </el-collapse-item>
        </el-collapse>

        <el-button type="goon" style="margin-left:45%; margin-top: 10px;" @click="Save()">确定</el-button>
    </div>
</template>

<script>
    export default {
        data() {
            return {
                //组织架构数据
                organizeList: [],

                project_id: "",
                change_staff: [],

            }
        },
        methods: {
            Save() {
                var project_id = this.project_id;
                var project_name = "";
                var change_staff = "";
                var change_staff_name = "";

                //循环分公司
                this.organizeList.forEach(company => {
                    //循环板块
                    company.organizeList.forEach(plate => {
                        //循环项目
                        plate.projectList.forEach(project => {
                            if (project.id === project_id) {
                                project_name = project.project_name
                            }
                            //循环员工
                            project.staffList.forEach(staff => {
                                this.change_staff.forEach(item => {
                                    change_staff = change_staff + "," + item
                                    if (staff.id === item) {
                                        if (change_staff_name != null &&
                                            change_staff_name != '') {
                                            change_staff_name =
                                                change_staff_name + "," + staff
                                                .staff_name;
                                        } else {
                                            change_staff_name = staff
                                            .staff_name;
                                        }
                                    }
                                })
                            })
                        })
                    })
                })

                //添加到父组件中
                this.$parent.$parent.form.attendants = change_staff;
                this.$parent.$parent.form.attendants_name = change_staff_name;

                //关闭
                this.$parent.$parent.dialogVisible = false;

                //清空数据
                this.change_staff = [];
            }
        },
        async created() {
            //初始化组织架构
            var organizeList = await this.$globals.AxiosPost("organize/selectOrganizeStaff", {
                identification: "1"
            });
            this.organizeList = organizeList.data;

            this.change_staff = [];
            this.$parent.$parent.form.attendants.split(",").forEach(item => {
                if (item != null && item != '') {
                    this.change_staff.push(parseInt(item))
                }
            })
        }
    }
</script>

<style scoped="scoped">
    >>>.el-collapse-item__content {
        padding-bottom: 0px;
    }
</style>



// WEBPACK FOOTER //
// KqzGl_add_setStaff.vue?42421d98